<script>
    import Layzr from 'layzr.js'

    export default {
        props: {
            src: String,
        },
        created() {
            if (!this.$root.layzr) {
                const instance = Layzr({
                    threshold: 33,
                });

                document.addEventListener('DOMContentLoaded', event => {
                    instance.update().check().handlers(true)
                });

                this.$root.layzr = instance;
            }
        }
    }
</script>

<template>
    <img :data-normal="src"/>
</template>
